//import external libraries
import React from "react";
import { Page, Document, View, Text } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

//import internal resources
import ProluxCardHeader from "./Components/ProluxCardHeader";
import NewTechCardInfo from "./Components/NewTechCardInfo";
import ProluxGeneralProductSpec from "./Components/ProluxGeneralProductSpec";
import ProluxHeatExchanger from "./Components/ProluxHeatExchanger";
import ProluxFan from "./Components/ProluxFan";
import SupplyAirAccessoires from "./SupplyAirAccessories";
import AluPlateHeatExch2 from "./Components/AluPlateHeatExch2";
import ExhaustAirAccessoires from "./ExhaustAirAccessories";
import AccessAndNotes from "./Access&Notes";
import ProluxFilter from "./Components/ProluxFilter";
import ProluxCoils from "./Components/ProluxCoils";
import FanChartReactPDF from ".././pages/tecnicalCard/fanChart/FanChartReactPDF";

const ProluxTechCardContent = ({ id, techData, heatRecovery, tittle }) => {
  const { t } = useTranslation();

  const today = new Date();
  const date =
    today.getDate() + "-" + (today.getMonth() + 1) + "-" + today.getFullYear();
  const dayNames = [
    t("daysOfWeek.sunday"),
    t("daysOfWeek.monday"),
    t("daysOfWeek.tuesday"),
    t("daysOfWeek.wednesday"),
    t("daysOfWeek.thursday"),
    t("daysOfWeek.friday"),
    t("daysOfWeek.saturday"),
  ];
  const day = today.getDay();

  return (
    <Document title={`Technisches Datenblatt`} author="Termovent Frameless">
      <Page
        wrap
        size="A4"
        pageMode="fullScreen"
        orientation="portrait"
        style={{ paddingHorizontal: "20px" }}
      >
        <ProluxCardHeader techData={techData} date={date} />
        <NewTechCardInfo techData={techData} />
        <ProluxGeneralProductSpec
          arrangement={techData.generalProductSpec.arrangement}
          insulation={techData.generalProductSpec.insulation}
          type={techData.generalProductSpec.supplySide.type}
          airVolumeFlow={techData.generalProductSpec.supplySide.airVolumeFlow}
          dimensions={
            techData.generalProductSpec.connectingSectionSupIn
              .flexibleConnection.dimensions
          }
          internalPressDrop={
            techData.calculation.supplyFanCalculation.internalPressDrop
          }
          supply={true}
          toSurroundings={techData.calculation.noiseLevels}
          exhaustFanCalculation={techData.calculation.exhaustFanCalculation}
          supplyFanCalculation={techData.calculation.supplyFanCalculation}
          sound_power_IN_125={
            techData.calculation.supplyFanCalculation.sound_power_IN_125
          }
          sound_power_IN_250={
            techData.calculation.supplyFanCalculation.sound_power_IN_250
          }
          sound_power_IN_500={
            techData.calculation.supplyFanCalculation.sound_power_IN_500
          }
          sound_power_IN_1000={
            techData.calculation.supplyFanCalculation.sound_power_IN_1000
          }
          sound_power_IN_2000={
            techData.calculation.supplyFanCalculation.sound_power_IN_2000
          }
          sound_power_IN_4000={
            techData.calculation.supplyFanCalculation.sound_power_IN_4000
          }
          sound_power_IN_8000={
            techData.calculation.supplyFanCalculation.sound_power_IN_8000
          }
          sound_power_OUT_125={
            techData.calculation.supplyFanCalculation.sound_power_OUT_125
          }
          sound_power_OUT_250={
            techData.calculation.supplyFanCalculation.sound_power_OUT_250
          }
          sound_power_OUT_500={
            techData.calculation.supplyFanCalculation.sound_power_OUT_500
          }
          sound_power_OUT_1000={
            techData.calculation.supplyFanCalculation.sound_power_OUT_1000
          }
          sound_power_OUT_2000={
            techData.calculation.supplyFanCalculation.sound_power_OUT_2000
          }
          sound_power_OUT_4000={
            techData.calculation.supplyFanCalculation.sound_power_OUT_4000
          }
          sound_power_OUT_8000={
            techData.calculation.supplyFanCalculation.sound_power_OUT_8000
          }
          sound_power_in={
            techData.calculation.supplyFanCalculation.sound_power_in
          }
          sound_power_out={
            techData.calculation.supplyFanCalculation.sound_power_out
          }
        />
        <ProluxFilter
          filterCalc={techData.calculation.supplyFilterCalculation}
          supply={true}
        />
        <ProluxHeatExchanger
          summerRecCalculation={techData.calculation.summerRecCalculation}
          winterRecCalculation={techData.calculation.winterRecCalculation}
        />
        <ProluxFan
          fanCalculation={techData.calculation.supplyFanCalculation}
          airflow={techData.generalProductSpec.supplySide.airVolumeFlow}
          exhaustFanCalculation={techData.calculation.exhaustFanCalculation}
          supplyFanCalculation={techData.calculation.supplyFanCalculation}
          sound_power_IN_125={
            techData.calculation.exhaustFanCalculation.sound_power_IN_125
          }
          sound_power_IN_250={
            techData.calculation.exhaustFanCalculation.sound_power_IN_250
          }
          sound_power_IN_500={
            techData.calculation.exhaustFanCalculation.sound_power_IN_500
          }
          sound_power_IN_1000={
            techData.calculation.exhaustFanCalculation.sound_power_IN_1000
          }
          sound_power_IN_2000={
            techData.calculation.exhaustFanCalculation.sound_power_IN_2000
          }
          sound_power_IN_4000={
            techData.calculation.exhaustFanCalculation.sound_power_IN_4000
          }
          sound_power_IN_8000={
            techData.calculation.exhaustFanCalculation.sound_power_IN_8000
          }
          sound_power_OUT_125={
            techData.calculation.exhaustFanCalculation.sound_power_OUT_125
          }
          sound_power_OUT_250={
            techData.calculation.exhaustFanCalculation.sound_power_OUT_250
          }
          sound_power_OUT_500={
            techData.calculation.exhaustFanCalculation.sound_power_OUT_500
          }
          sound_power_OUT_1000={
            techData.calculation.exhaustFanCalculation.sound_power_OUT_1000
          }
          sound_power_OUT_2000={
            techData.calculation.exhaustFanCalculation.sound_power_OUT_2000
          }
          sound_power_OUT_4000={
            techData.calculation.exhaustFanCalculation.sound_power_OUT_4000
          }
          sound_power_OUT_8000={
            techData.calculation.exhaustFanCalculation.sound_power_OUT_8000
          }
          sound_power_in={
            techData.calculation.exhaustFanCalculation.sound_power_in
          }
          sound_power_out={
            techData.calculation.exhaustFanCalculation.sound_power_out
          }
        />
        <ProluxCoils coilsCalc={techData.calculation.heating} heater={true} />
        <ProluxCoils coilsCalc={techData.calculation.cooling} heater={false} />
        {/*<NewTechCardAirCooler coilsCalc={techData.calculation.cooling} />*/}
        <SupplyAirAccessoires techData={techData} />
        <ProluxGeneralProductSpec
          arrangement={techData.generalProductSpec.arrangement}
          insulation={techData.generalProductSpec.insulation}
          type={techData.generalProductSpec.exhaustSide.type}
          airVolumeFlow={techData.generalProductSpec.exhaustSide.airVolumeFlow}
          dimensions={
            techData.generalProductSpec.connectingSectionEhaIn
              .flexibleConnection.dimensions
          }
          internalPressDrop={
            techData.calculation.exhaustFanCalculation.internalPressDrop
          }
          supply={false}
          sound_power_IN_125={
            techData.calculation.exhaustFanCalculation.sound_power_IN_125
          }
          sound_power_IN_250={
            techData.calculation.exhaustFanCalculation.sound_power_IN_250
          }
          sound_power_IN_500={
            techData.calculation.exhaustFanCalculation.sound_power_IN_500
          }
          sound_power_IN_1000={
            techData.calculation.exhaustFanCalculation.sound_power_IN_1000
          }
          sound_power_IN_2000={
            techData.calculation.exhaustFanCalculation.sound_power_IN_2000
          }
          sound_power_IN_4000={
            techData.calculation.exhaustFanCalculation.sound_power_IN_4000
          }
          sound_power_IN_8000={
            techData.calculation.exhaustFanCalculation.sound_power_IN_8000
          }
          sound_power_OUT_125={
            techData.calculation.exhaustFanCalculation.sound_power_OUT_125
          }
          sound_power_OUT_250={
            techData.calculation.exhaustFanCalculation.sound_power_OUT_250
          }
          sound_power_OUT_500={
            techData.calculation.exhaustFanCalculation.sound_power_OUT_500
          }
          sound_power_OUT_1000={
            techData.calculation.exhaustFanCalculation.sound_power_OUT_1000
          }
          sound_power_OUT_2000={
            techData.calculation.exhaustFanCalculation.sound_power_OUT_2000
          }
          sound_power_OUT_4000={
            techData.calculation.exhaustFanCalculation.sound_power_OUT_4000
          }
          sound_power_OUT_8000={
            techData.calculation.exhaustFanCalculation.sound_power_OUT_8000
          }
          sound_power_in={
            techData.calculation.exhaustFanCalculation.sound_power_in
          }
          sound_power_out={
            techData.calculation.exhaustFanCalculation.sound_power_out
          }
        />
        <ProluxFilter
          filterCalc={techData.calculation.supplyFilterCalculation}
          supply={false}
        />
        {/*<ExhaustAir techData={techData} />*/}
        <AluPlateHeatExch2 techData={techData} />
        <ProluxFan
          fanCalculation={techData.calculation.exhaustFanCalculation}
          airflow={techData.generalProductSpec.exhaustSide.airVolumeFlow}
          sound_power_IN_125={
            techData.calculation.supplyFanCalculation.sound_power_OUT_125
          }
          sound_power_IN_250={
            techData.calculation.supplyFanCalculation.sound_power_OUT_250
          }
          sound_power_IN_500={
            techData.calculation.supplyFanCalculation.sound_power_OUT_500
          }
          sound_power_IN_1000={
            techData.calculation.supplyFanCalculation.sound_power_OUT_1000
          }
          sound_power_IN_2000={
            techData.calculation.supplyFanCalculation.sound_power_OUT_2000
          }
          sound_power_IN_4000={
            techData.calculation.supplyFanCalculation.sound_power_OUT_4000
          }
          sound_power_IN_8000={
            techData.calculation.supplyFanCalculation.sound_power_OUT_8000
          }
          sound_power_OUT_125={
            techData.calculation.exhaustFanCalculation.sound_power_IN_125
          }
          sound_power_OUT_250={
            techData.calculation.exhaustFanCalculation.sound_power_IN_250
          }
          sound_power_OUT_500={
            techData.calculation.exhaustFanCalculation.sound_power_IN_500
          }
          sound_power_OUT_1000={
            techData.calculation.exhaustFanCalculation.sound_power_IN_1000
          }
          sound_power_OUT_2000={
            techData.calculation.exhaustFanCalculation.sound_power_IN_2000
          }
          sound_power_OUT_4000={
            techData.calculation.exhaustFanCalculation.sound_power_IN_4000
          }
          sound_power_OUT_8000={
            techData.calculation.exhaustFanCalculation.sound_power_IN_8000
          }
          sound_power_in={
            techData.calculation.supplyFanCalculation.sound_power_out
          }
          sound_power_out={
            techData.calculation.exhaustFanCalculation.sound_power_in
          }
        />
        <ExhaustAirAccessoires techData={techData} />
        <AccessAndNotes techData={techData} />
        {techData.calculation.supplyFanCalculation.fanChart !== "" &&
          techData.calculation.supplyFanCalculation.fanChart !== "-" && (
            <View break /*style={styles["img-center"]}*/>
              <Text
                style={{
                  fontSize: "12px",
                  fontWeight: "600",
                  marginTop: "15px",
                  paddingHorizontal: "5px",
                }}
              >
                Diagramm des Zuluftventilators
              </Text>
              <FanChartReactPDF
                type={techData.calculation.supplyFanCalculation.type}
                chartFile={JSON.parse(
                  techData.calculation.supplyFanCalculation.fanChart
                )}
              />
            </View>
          )}
        {techData.calculation.exhaustFanCalculation.fanChart !== "" &&
          techData.calculation.exhaustFanCalculation.fanChart !== "-" && (
            <View break /*style={styles["img-center"]}*/>
              <Text
                style={{
                  fontSize: "12px",
                  fontWeight: "600",
                  marginTop: "15px",
                  paddingHorizontal: "5px",
                }}
              >
                Diagramm des Abluftventilators
              </Text>
              <FanChartReactPDF
                type={techData.calculation.exhaustFanCalculation.type}
                chartFile={JSON.parse(
                  techData.calculation.exhaustFanCalculation.fanChart
                )}
              />
            </View>
          )}
      </Page>
    </Document>
  );
};

export default ProluxTechCardContent;
